import { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { CommissionList } from './CommissionList';
import { CompanyFilter } from './CompanyFilter';
import MPPaymentOnDeliveryCommissionQuery from '@/services/query/mpPaymentOnDeliveryCommission/MPPaymentOnDeliveryCommission.services';
import { MPODC } from '../mpPaymentOnDeliveryCommission.classes';

type PaginationModel = {
    pageSize: number;
    pageNumber: number; // 1-based (API)
    totalCount: number;
};

export const CommissionListTab = ({
    setIsLoading,
    companyOptions,
}: {
    setIsLoading: (isLoading: boolean) => void;
    isLoading: boolean;
    companyOptions: any[];
}) => {
    const [filterCompanyId, setFilterCompanyId] = useState<number>(-1);
    const [commissionList, setCommissionList] = useState<any>(null);
    const [companyList, setCompanyList] = useState<any>(companyOptions);
    const [pagination, setPagination] = useState<PaginationModel>({ pageSize: 10, pageNumber: 1, totalCount: 0 });

    const companyName = useMemo(
        () => (companyList || [])?.find((item: any) => item.id === filterCompanyId)?.name,
        [companyList, filterCompanyId]
    );

    const fetchList = () => {
        setIsLoading(true);
        MPPaymentOnDeliveryCommissionQuery.GetCodCommissionRanges({
            shippingCompanyId: filterCompanyId,
            pageNumber: pagination.pageNumber,
            pageSize: pagination.pageSize,
        })
            .then((res: any) => {
                const data = res?.getCodCommissionRanges || [];
                const rowsWithId = (data || [])?.map((item: any, index: number) => ({
                    ...item,
                    id: index,
                    startDate: item?.startDate ?? null,
                    expirationDate: item?.expirationDate ?? null,
                    lastModifiedDate: item?.lastModifiedDate ?? null,
                    lastModifiedBy: item?.lastModifiedBy ?? '',
                }));
                setCommissionList(rowsWithId || []);
                setPagination((prev) => ({
                    ...prev,
                    totalCount: Number(res?.totalCount ?? 0),
                }));
            })
            .catch(() => setCommissionList([]))
            .finally(() => setIsLoading(false));
    };

    useEffect(() => {
        if (commissionList === null) return;
        if (filterCompanyId === -1) return;
        fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.pageNumber, pagination.pageSize]);

    return (
        <Box className={MPODC.listTabRoot} width="100%">
            {commissionList === null && (
                <CompanyFilter
                    setIsLoading={setIsLoading}
                    setFilterCompanyId={setFilterCompanyId}
                    filterCompanyId={filterCompanyId}
                    fetchList={() => {
                        setPagination((prev) => ({ ...prev, pageNumber: 1 }));
                        fetchList();
                    }}
                    companyList={companyList}
                    setCompanyList={setCompanyList}
                />
            )}
            {commissionList !== null && (
                <CommissionList
                    rows={commissionList || []}
                    setIsLoading={setIsLoading}
                    filterCompanyId={filterCompanyId}
                    setRows={setCommissionList}
                    fetchList={fetchList}
                    companyOptions={companyList || []}
                    companyName={companyName}
                    pagination={pagination}
                    onPageChange={(pageZeroBased: number) => {
                        setPagination((prev) => ({ ...prev, pageNumber: pageZeroBased + 1 }));
                    }}
                    onPageSizeChange={(newPageSize: number) => {
                        setPagination((prev) => ({ ...prev, pageSize: newPageSize, pageNumber: 1 }));
                    }}
                />
            )}
        </Box>
    );
};
